const APP_PROFILE = '/profile';

const APP_EMAIL_EDIT_MAGIC_LINK_VERIFICATION =
  '/user/email/edit/:userID/verify/';

export { APP_EMAIL_EDIT_MAGIC_LINK_VERIFICATION, APP_PROFILE };
